<template>
  <div class="userWrap">
    <h4>修改支付密码</h4>

    <div class="formWrap">
      <el-form :model="resetPayForm" :rules="rules" ref="resetPayForm" label-width="0" class="resetPayForm">
        <el-form-item prop="password">
          <p>新密码</p>
          <el-input type="password" v-model="resetPayForm.password" size="medium" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="checkPassword">
          <p>确认新密码</p>
          <el-input type="password" v-model="resetPayForm.checkPassword" size="medium" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="pay_password">
          <p>支付密码</p>
          <el-input type="password" v-model="resetPayForm.pay_password" size="medium" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item prop="code">
          <p>验证码 <span class="signTel">接收邮箱 {{signEmail}}</span></p>
          <el-input v-model="resetPayForm.code" size="medium" autocomplete="off">
            <template slot="append">
              <span @click="getEmailOPT">{{optWords}}</span>
            </template>
          </el-input>
        </el-form-item>

        <div class="submit">
          <el-button type="primary" size="medium" @click="regForm('resetPayForm')">
            {{pc_lang.Confirm_submission}}
          </el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import * as API_USER from '@/api/user'
import * as RegExp from '@/utils/RegExp'

export default {
  name: 'UserResetPayPassword',
  components: {

  },
  data() {
    return {
      resetPayForm: {
        password: '',
        checkPassword: '',
        pay_password: '',
        code: '',
        type: 'email'
      },
      optTimer: null,
      optBool: 1,
      optWords2: ''
    }
  },
  computed: {
    ...mapGetters(['user']),
    /* 手机加密 */
    signEmail() {
      let email = this.user.email
      return !!!email ? '' : email.replace(/^(\S{3})\S*(\S{3})$/,'$1****$2')
    },
    rules() {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_the_password));
        } else if( !RegExp.payword.test(value) ) {
          callback(new Error(this.pc_lang.Password_consists_of_6_digits));
        } else {
          if (this.resetPayForm.checkPassword !== '') {
            this.$refs.resetPayForm.validateField('checkPassword');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Please_enter_the_password_again));
        } else if (value !== this.resetPayForm.password) {
          callback(new Error(this.pc_lang.The_passwords_entered_twice_are_inconsistent));
        } else {
          callback();
        }
      };
      let validatePay = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.pc_lang.Enter_the_password));
        } else if( !RegExp.payword.test(value) ) {
          callback(new Error(this.pc_lang.Password_consists_of_6_digits));
        }else {
          callback();
        }
      };
      return {
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        pay_password: [
          { validator: validatePay, trigger: 'blur' }
        ],
        /*code: [
          { required: true, message: this.pc_lang.Enter_verification_code, trigger: 'blur' },
          { min: 6, max: 6, message: '长度为6个字符', trigger: 'blur' }
        ]*/
      }
    },
    // 验证码单词
    optWords: {
      get() {
        return this.optWords2 == "" ? this.pc_lang.Get_verification_code : this.optWords2
      },
      set(val) {
        this.optWords2 = val
      }
    }
  },
  async mounted() {

  },
  beforeDestroy() {
    try{
      window.clearInterval(this.optTimer)
    }catch(err){}
    this.optTimer = null
  },
  created() {

  },
  methods: {
    /* 表单验证 */
    regForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // this.regOPT()
          this.submit()
        }
      })
    },
    /* 获取验证码 */
    getOPT() {
      if (this.optBool) {
        this.optBool = 0
        API_USER.paypwdSMS().then(res=>{
          let num = res.data || 120
          let optTimer = setInterval(()=> {
            num--
            let word = this.pc_lang.Get_the_code_after_3s.replace(/3/, num)
            if (num <= 0) {
              clearInterval(optTimer)
              this.optWords = this.pc_lang.Get_verification_code
              this.optBool = 1
              return false
            }else{
              this.optWords = word
            }
          }, 1000)
        },rej=> {
          this.optBool = 1
          this.$message.error(rej.msg)
        })
      }
    },
    /* 获取验证码 */
    getEmailOPT() {
      if (this.optBool) {
        this.optBool = 0
        API_USER.pwdEmail().then(res=>{
          let num = res.data || 120
          let optTimer = setInterval(()=> {
            num--
            let word = this.pc_lang.Get_the_code_after_3s.replace(/3/, num)
            if (num <= 0) {
              clearInterval(optTimer)
              this.optWords = this.pc_lang.Get_verification_code
              this.optBool = 1
              return false
            }else{
              this.optWords = word
            }
          }, 1000)
        },rej=> {
          this.optBool = 1
          this.$message.error(rej.msg)
        })
      }
    },
    /* 验证验证码 */
    regOPT() {
      // 场景(修改密码:MODIFY_LOGIN_PASSWORD,修改支付密码:MODIFY_PAY_PASSWORD)
      const params = {
        code: this.resetPayForm.code,
        scene: 'MODIFY_PAY_PASSWORD'
      }
      API_USER.verifycode(params).then(res=> {
        this.submit()
      },
      rej=> {
        this.$message.error(rej.msg)
      })
    },
    /* submit */
    submit() {
      let params = JSON.parse(JSON.stringify(this.resetPayForm))
      params.password = md5(params.password)

      API_USER.editpaypwdsEmail(params, params.type).then(res=> {
        this.$message.success(this.pc_lang.Successful_operate)
        const sn = this.$route.query.tradeSerialNo
        if ( !!sn ) {
          this.$router.push({ path: `/pay?tradeSerialNo=${sn}` })
        } else {
          this.$router.push({ name: 'UserSafety' })
        }
      },
      rej=> {
        this.$message.error(rej.msg)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>